/**
 * Copyright © 2022 Anagog Ltd. All rights reserved.
 */

import { NativeModules } from "react-native";
const { JedAIModule } = NativeModules;

export class Campaign {

    public readonly title: string;
    public readonly identifier: string;
  
    constructor(title: string, identifier: string) {
      this.title = title;
      this.identifier = identifier;
    }

    /**
     * Simulate this campaign, use this API to test your campaigns as defined.
     */
    public simulate() {
        JedAIModule.simulateCampaign(this.identifier);
    }
  
}